import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const RecordSharePointUpload = () => {
    useBrowserTabTitle('Record SharePoint Upload')
    return (
        <SharePointUpload
            entityType="Record"
            apiPath="records"
            statusField="record_status"
        />
    )
};

export default RecordSharePointUpload
